/**
 * Production-safe logging utility
 * Disables debug logs in production to prevent exposing sensitive data
 */

const isDev = process.env.NODE_ENV === 'development';

export const logger = {
  /**
   * Debug logging - only in development
   * Use for verbose debugging information
   */
  log: (...args: any[]) => {
    if (isDev) {
      console.log(...args);
    }
  },

  /**
   * Debug logging - only in development
   * Use for detailed debugging information
   */
  debug: (...args: any[]) => {
    if (isDev) {
      console.debug(...args);
    }
  },

  /**
   * Info logging - only in development
   * Use for general information
   */
  info: (...args: any[]) => {
    if (isDev) {
      console.info(...args);
    }
  },

  /**
   * Warning logging - always enabled
   * Use for non-critical issues that should be investigated
   */
  warn: (...args: any[]) => {
    console.warn(...args);
  },

  /**
   * Error logging - always enabled
   * Use for errors that need immediate attention
   */
  error: (...args: any[]) => {
    console.error(...args);
  },
};

export default logger;
